import { isRequiredText, strMax } from '../utils';
export const professionalUnitContactValidate = {
    contactType: [isRequiredText('ご希望の返信方法を選択してください')],
    content: [
        isRequiredText('問い合わせ内容を入力してください'),
        strMax(5000, '問い合わせ内容は5000文字以内で入力してください'),
    ],
    questionType: [isRequiredText('問い合わせ項目を選択してください')],
};
export default professionalUnitContactValidate;
